import { FormatDateYMD } from "../functions/function";

export const AUTH_LOGIN = `user/login`;
export const AUTH_LOGIN_LARK = `user/login-lark`;
export const AUTH_LOGOUT = `user/logout`;
export const AUTH_VERIFY = `user/check_auth`;

//-------------------------------------------------------------------------------------------------------------------------------------------------
export const CHECKER_UPDATE_SHIPPING =
  //2024-01-11
  `order/update_shipping`;

export const CHECKER_GET_FILE_PATH = (order_no: string) =>
  `order/get_file_path?order_no=${order_no}`;

export const CHECKER_FIX_FILE = `static/re_upload/shipping_doc`;

export const CHECKER_GEN_BATCH = `batch/gen_batch_focus`;

export const CHECKER_GEN_BATCH_FAST_DELIVERY = `batch/gen_batch_focus`;

export const CHECKER_GEN_BATCH_BY_ORDER = (orderNo: string) =>
  `batch/gen-batch-by-order/${orderNo}`;

export const CHECKER_PRINT_BY_BATCH = `batch/download_by_batch`;

export const CHECKER_GET_BATCH_ITEMS_FILTER = `batch-items/filter`;

export const CHECKER_UPDATE_BATCH_ITEM_BY_ID = (id: number) => `batch-items/${id}`;

export const CHECKER_DOWNLOAD_BATCH_ITEM = `batch-items/download`;

export const CONSTANT_PLATFORM = `const/get_platform`;

export const CONSTANT_BRAND_2 = `const/get_platform_brand`;

export const CHECK_UPLOAD_ORDER = `order/find_missing_orders`;

export const RE_INSERT_ORDER = `order/re_insert_order`;

export const CONSTANT_BRAND = `const/get_brand`;

export const CHECKER_UPLOAD_TRACKING = `order/update_tracking_no`;

export const CHECKER_UPLOAD_INVOICE = `order/update_info_invoice`;

export const CHECKER_CALENDAR = (date: any) =>
  `order/summary_orders_calendar?date=${FormatDateYMD(date)}`;

export const CHECKER_GET_ORDER = (type: string, startDate: any, endDate: any) =>
  `order/get_all_orders?start_date=${FormatDateYMD(startDate)}&end_date=${FormatDateYMD(endDate)}&str_status=${type}`;

export const CHECKER_GET_ORDER_SO = (startDate: any, endDate: any) =>
  `order/get_all_orders_so?start_date=${FormatDateYMD(startDate)}&end_date=${FormatDateYMD(endDate)}`;

export const CHECKER_OPEN_SO_RESULT = `pack/open_sale_order/result`;

export const CHECKER_RESYNC_WAY_BILL = (orderNo: string) =>
  `pack/resync-waybill?order_no=${orderNo}`;

export const CHECKER_CANCEL_SO = `sale-order/cancel`;

export const CHECKER_SEARCH_BY_ORDER = `order/search_order`;

export const CHECKER_ORDERS_FILTER = `orders/filter`;

export const CHECKER_SEARCH_BY_ORDER_SO = `sale-order/search-order-so`;

export const CHECKER_GET_ORDER_DETAIL = () => `order/get_order_details`;

export const CHECKER_GET_ORDER_LINE = () => `order/get_order_line`;

export const CHECKER_UPDATE_STATUS = () => `order/update_order_status`;

export const CHECKER_GET_NAME_BY_SKU = () => `order/get_product_name`;

export const CHECKER_DELETE_SKU = () => `order/delete_item`;

export const CHECKER_UPDATE_RUN_NUMBER = () => `order/update_run_number`;

export const CHECKER_INSERT_NEW_SKU = () => `order/insert_order_line`;

export const CHECKER_SUM_ORDER_BY_DATE = (date: any) =>
  `order/summary_orders_by_date?date=${FormatDateYMD(date)}`;

export const CHECKER_SUM_SKU_BY_DATE = (date: any) =>
  `order/summary_sku_by_date?date=${FormatDateYMD(date)}`;

export const CHECKER_NEW_SUM_ORDER_BY_DATE = (date: any) =>
  `daily-order-summaries/by-date?date=${FormatDateYMD(date)}`;

export const CHECKER_NEW_SUM_SKU_BY_DATE = (date: any) =>
  `daily-order-summaries/sku/by-date?date=${FormatDateYMD(date)}`;

export const CHECKER_SUM_ORDER_EXPRESS_BY_DATE = (date: any) =>
  `daily-order-summaries/express-deliveries/by-date?date=${FormatDateYMD(date)}`;

export const CHECKER_SUM_SKU_EXPRESS_BY_DATE = (date: any) =>
  `daily-order-summaries/express-deliveries/sku/by-date?date=${FormatDateYMD(date)}`;

export const CHECKER_GET_SKU = () => `order/get_all_products?warehouse`;

export const CHECKER_GET_RESERVE_STOCK = (warehouse: string, date: string, location: string) =>
  `reserve_stock/get_reserve_stock?warehouse=${warehouse}&date=${FormatDateYMD(date)}&location=${location}`;

export const CHECKER_CONFIRM_ORDER = (warehouse: string) =>
  `reserve_stock/update_confirm_order?warehouse=${warehouse}`;

export const CHECHKER_GET_USER_DCOM = `user/get_users_dcom`;

export const CHECHKER_GET_ALL_USER = `user/get_users_warehouse`;

export const CHECHKER_INSERT_NEW_USER = `user/insert_user`;

export const CHECHKER_UPDATE_ROLE_USER = `user/update_user_role`;

export const CHECHKER_UPDATE_REMOVE_USER = `user/delete_user`;

export const CHECKER_POST_DUPLICATE_USER = `user/check_duplicate_username`;

export const CHECKER_VALIDATE_BATCH = `pick/check_batch`;

export const CHECKER_LOCKED_BATCH = `pick/lock_batch`;

export const CHECKER_UNLOCK_BATCH = `pick/unlock_batch`;

export const CHECKER_NO_ITEM = `pick/no_item`;

export const CHECKER_CONFIRM_NO_ITEM = `pick/confirm_no_item`;

export const CHECKER_CONFIRM_PICK = `pick/confirm_pick`;

export const UPDATE_TRACKING = `order/update_tracking_no`;

export const GET_UNCHECKOUT_ORDER = `orders/get-uncheckout-orders`;

export const CHECKER_GET_PICK_SKU = (batch_id: string, brand: string) =>
  `pick/get_items?batch_id=${batch_id}&brand=${brand}`;

export const CHECKER_GET_STAT = (type: string) => `stat?type=${type}`;

export const CHECKER_CONFIRM_PACK = `pack/confirm_pack`;

export const CHECKER_OPEN_SO = `pack/open_sale_order`;

export const CHECKER_FILE_ERR = `pack/shipping_doc_error`;

export const CHECKER_GET_PACK_ORDER = (batch_id: string, brand: string) =>
  `pack/get_orders?batch_id=${batch_id}&brand=${brand}`;

export const CHECKER_GET_PACK_SKU = (order_no: string, tracking_no: string) =>
  `pack/get_items?order_no=${order_no}&tracking_no=${tracking_no}`;

export const GET_RECEIPT = (order_no: string, tracking_no: string) => {
  const params = new URLSearchParams();
  params.append("order_no", order_no);
  params.append("tracking_no", tracking_no);
  return `pack/get_receipt?${params.toString()}`;
};

export const GET_LIST_CHECKOUT = (checkoutDate: string, type: string, warehouse: string) =>
  `check-out/get-list?&checkoutDate=${checkoutDate}&checkoutType=${type}&warehouse=${warehouse}`;

export const GETLOGISTIC = `v2/const/logistic`;

export const CONFIRM_SHIPPING = `check-out/confirm-shipping`;

export const CANCEL_SHIPPING = `check-out/cancel-shipping`;

export const GET_ORDER_SUMMARY = (date: string) => `check-out/get-summary?&checkoutDate=${date}`;

export const GETWAITHOLD = `v2/edit-order/get-hold-wait`;

export const GETALLPRODUCT = `v2/const/product-list`;

export const ADDFREEGIFT = `v2/edit-order/add-free-gift`;

export const GET_ORDER_DETAIL_BY_ORDERNO = (order_no: string, no: string) =>
  `v2/order/by-order?orderNo=${order_no}&no=${no}`;

export const EDIT_ITEM_BY_ORDER = `v2/edit-order/by-order`;

export const EDIT_ITEM_MUTI_ORDER = `v2/edit-order/multi-order`;

export const GET_ORDER_BY_SKU = (sku: string) => `v2/order/order-line-by-sku?sku=${sku}`;

export const CHANGE_STATUS_READY = "v2/order/wait-to-ready";

export const CHANGE_STATUS_HOLD = "v2/order/wait-to-hold";

export const GET_ORDER_WAREHOUSE = (type: string, startDate: any, endDate: any) =>
  `v2/order/warehouse?startDate=${FormatDateYMD(startDate)}&endDate=${FormatDateYMD(endDate)}&strStatus=${type}`;

export const CHECKER_GET_ORDER_HYDRO_CHAT = (startDate: any, endDate: any) =>
  `order/get_hydro_by_date?start_date=${FormatDateYMD(startDate)}&end_date=${FormatDateYMD(endDate)}`;

export const CHECKER_SEARCH_HYDRO_BY_ORDER = (order_no: string) =>
  `order/get_hydro_by_order_no?order_no=${order_no}`;

export const CHECKER_UPDATE_HYDRO_CHAT = `order/update_hydro_alter_sku`;

export const UPLIFT_GET_ALL_CUTTING = (
  page_size: string,
  current_page: string,
  search?: string,
) => {
  let api_path = "cutting/get_master?";
  if (search) {
    api_path = api_path + `search=${search}&`;
  }
  const result = api_path + `page_size=${page_size}&current_page=${current_page}`;
  return result;
};

//use create master when create many
export const UPLIFT_CREATE_CUTTING = `cutting/create_master`;
// use update cutting when update each one
export const UPLIFT_UPDATE_CUTTING = `cutting/update_master`;

export const UPLIFT_GET_CUTTING_ITEM = (batch_id: string, brand: string) => {
  return `cutting/get_items?batch_id=${batch_id}&brand=${brand}`;
};

//HDP -> api to sedn to film cutting device kub
export const HDP_GET_CUTTING_STATUS = () => {
  return `${process.env.REACT_APP_PRINTER}/cutting/status`;
};

export const HDP_GET_CUTTING_READY = () => {
  return `${process.env.REACT_APP_PRINTER}/cutting/ready`;
};

export const HDP_GET_CUTTING_BALANCE = () => {
  return `${process.env.REACT_APP_PRINTER}/cutting/balance`;
};

export const HDP_GET_CUTTING_EXECUTE = () => {
  return `${process.env.REACT_APP_PRINTER}/cutting/execute`;
};

export const UPLIFT_GET_CUTTING_QTY = (batch_id: string) => `cutting/qty?batch_id=${batch_id}`;

export const UPLIFT_SUBMIT_CUTTING = (batch_id: string) => `cutting/${batch_id}/complete`;

export const UPLIFT_EXECUTE_CUTTING = `cutting/qty/execute`;

export const UPLIFT_LOGS_CUTTING = `cutting/logs`;

export const UPLIFT_CREATE_CUTTING_QTY = (batch_id: string) =>
  `cutting/qty/create?batch_id=${batch_id}`;

export const GET_ALL_LOG_STATUS = (order_no: string) => {
  const params = new URLSearchParams();
  params.append("order_no", order_no);

  return `order_history/?${params.toString()}`;
};

export const CHECKER_SUPERVISOR_DASHBOARD = (type: string) => `stat/supervisor?type=${type}`;

export const BATCH_SCHEDULE_LIST = `cronjob/config`;
export const BATCH_SCHEDULE_UPDATE = (id: number) => `cronjob/config/${id}`;

export const SHIPPING_SEARCH = (
  status: string,
  limit: number,
  sort: string,
  dir: string,
  date = "",
) => `shipping/search?status=${status}&limit=${limit}&sort=${sort}&dir=${dir}&date=${date}`;
export const SHIPPING_VALIDATE_UPDATE = `shipping/validate-update`;
export const SHIPPING_UPDATE_CHECKED = `shipping/update-checked-shippings`;
export const SHIPPING_REVERT_CHECKED = `shipping/revert-checked`;
